import Link from 'gatsby-link';
import React from 'react';

import AddThis from '../components/add-this.js';
import Categories from '../components/categories.js';
import Tags from '../components/tags.js';

export default ({ data, pathContext }) =>
  <div>
    <div className="breadcrumb">
      <Link to="/">
        Home
      </Link>
      <span> › </span>
      <Link to="/articles/">
        Blog
      </Link>
      <span> › </span>
      {data.articlesYaml.title}
    </div>

    <div className="title">
      {data.articlesYaml.title}
    </div>

    <div className="subtitle">
      {data.articlesYaml.subtitle}
    </div>

    <p dangerouslySetInnerHTML={{ __html: data.articlesYaml.fields.abstractHtml }}/>

    <hr/>

    <Tags tags={data.articlesYaml.tags}/>

    <div dangerouslySetInnerHTML={{ __html: data.articlesYaml.fields.textHtml }} />

    <hr/>

    <Categories categories={data.articlesYaml.categories}/>

    <AddThis />
  </div>
;

export const fragments = graphql`
  fragment ArticleFields on ArticlesYaml {
    abstract
    authors
    categories
    date
    fields {
      abstractHtml
      textHtml
    }
    language
    permalink
    publish
    reviewed
    subtitle
    tags
    title
    visible
  }
`;

export const query = graphql`
  query Article($permalink: String!) {
    articlesYaml(permalink: { eq: $permalink }) {
      ...ArticleFields
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/article.js